import { Menu } from "@mui/material";
import { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import DropDownMenu from "./DropDownMenu";
import {
  PrimaryButton,
  Reject,
  Accept,
  AcceptUpload,
  PrimaryLoadingButton,
  CreateButtonLoading,
} from "../../css components/Button";
import pages from "../../../constants/pages";
import { useAxios } from "../../../hooks";
import { alert } from "../../../redux/slices/alertSlice";
import LockMyCampaignDialog from "./campaign form components/LockMyCampaignDialog";

export default function CampaignButtons({
  editState,
  liveUsers,
  formikProps,
  component,
  brandIdentity,
  setTakeUpOffer,
  setDialogUploadCSV,
  setBroadcastReportDialog,
}) {
  const axios = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [confirm, setConfirm] = useState({
    state: false,
  });

  const [dialog, setDialog] = useState({ state: false });
  const [loading, setLoading] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);

  const [launchCampaign, setLaunchCampaign] = useState(true);
  const [lockCampaignLoading, setLockCampaignLoading] = useState(false);

  const { activeBrand, userID } = useSelector((state) => state.memberDetails);

  return (
    <Fragment>
      {component === "" &&
        Boolean(formikProps.values?.adminCampaignStatus) &&
        formikProps.values?.campaignLaunched &&
        !formikProps.values.campaignInitiated &&
        launchCampaign && (
          <Accept
            variant="contained"
            onClick={() => setConfirm({ state: true })}
            sx={{ marginLeft: "12px" }}
          >
            {" "}
            Launch Campaign
          </Accept>
        )}

      {formikProps.values.campaignID &&
        !editState &&
        formikProps.values.permissionSettings.lock_campaign &&
        formikProps.values?.status === "CREATED" && (
          <CreateButtonLoading
            style={{ marginLeft: "5px" }}
            loading={lockCampaignLoading}
            onClick={() => {
              setDialog({
                state: true,
                heading: " lock campaign?",
                button: "Lock My Campaign",
                func: handleLockCampaign,
              });
            }}
            variant="contained"
          >
            Lock my Campaign
          </CreateButtonLoading>
        )}

      {formikProps.values.campaignID &&
        !editState &&
        formikProps.values.permissionSettings.sent_for_approval &&
        formikProps.values?.status === "CREATED" &&
        !formikProps.values.adminApprovalStatus && (
          <CreateButtonLoading
            variant="contained"
            style={{ marginLeft: "5px" }}
            loading={lockCampaignLoading}
            onClick={() => {
              setDialog({
                state: true,
                heading: " send request for campaign approval?",
                button: "Send for approval",
                func: sendForApproval,
              });
            }}
          >
            Send for Approval
          </CreateButtonLoading>
        )}

      {formikProps.values?.campaignID &&
        formikProps.values?.status === "ACTIVE" &&
        formikProps.values?.requestStatus === "ACCEPTED" &&
        formikProps.values.permissionSettings.display_stats && (
          <PrimaryButton
            onClick={() =>
              navigate(
                pages.analytics.route +
                  formikProps.values.campaignID +
                  "?campaignName=" +
                  formikProps.values?.campaign_name?.value
              )
            }
            variant="contained"
          >
            Analytics
          </PrimaryButton>
        )}

      {component === "superadmin" && (
        <Accept
          size="large"
          variant="contained"
          style={{ marginRight: "15px" }}
        >
          Approve Campaign
        </Accept>
      )}

      {brandIdentity &&
        component !== "accepted" &&
        formikProps.values.status !== "ACTIVE" &&
        formikProps.values.campaignStatus !== "REJECTED" &&
        formikProps.values.campaignStatus !== "ACCEPTED" &&
        formikProps.values.campaignStatus !== "PARTIAL_ACCEPTED" &&
        formikProps.values.campaignStatus !== "PARTIAL_REJECTED" &&
        formikProps.values.campaignStatus !== "MISSED" && (
          <Fragment>
            <Reject
              size="large"
              variant="contained"
              style={{ marginRight: "15px" }}
              onClick={() =>
                setTakeUpOffer((prevVal) => ({
                  ...prevVal,
                  action: "REJECTED",
                  state: true,
                }))
              }
            >
              Reject
            </Reject>

            <Accept
              size="large"
              variant="contained"
              disabled={
                parseInt(liveUsers?.liveUser) <= 0 || !liveUsers.liveUser
              }
              style={{ marginRight: "15px" }}
              onClick={() =>
                setTakeUpOffer((prevVal) => ({
                  ...prevVal,
                  action: "ACCEPTED",
                  state: true,
                }))
              }
            >
              Accept
            </Accept>
          </Fragment>
        )}

      {component === "request" &&
        formikProps.values.csvUpload &&
        (formikProps.values.campaignStatus === "REQUESTED" ||
          formikProps.values.campaignStatus === "REJECTED") && (
          <AcceptUpload
            variant="contained"
            onClick={() => setDialogUploadCSV(true)}
          >
            UPLOAD ACCEPT
          </AcceptUpload>
        )}

      {formikProps.values.status === "ACTIVE" &&
        formikProps.values.requestStatus !== "MISSED" && (
          <Fragment>
            <PrimaryLoadingButton
              variant="outlined"
              size="large"
              loading={loading}
              sx={{
                marginLeft: "5px",
                whiteSpace: "nowrap",
              }}
              onClick={(event) => {
                if (component === "") {
                  setMenuAnchor(event.currentTarget);
                }

                if (component === "request") {
                  handleDownloadReport();
                }
              }}
            >
              Report
            </PrimaryLoadingButton>

            <Menu
              style={{ marginTop: "10px" }}
              open={!!menuAnchor}
              anchorEl={menuAnchor}
              onClose={() => setMenuAnchor(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <DropDownMenu
                formikProps={formikProps}
                setLoading={setLoading}
                setMenuAnchor={setMenuAnchor}
              />
            </Menu>
          </Fragment>
        )}

      <LockMyCampaignDialog
        dialog={dialog}
        setDialog={setDialog}
        handleLockCampaign={handleLockCampaign}
        lockCampaignLoading={lockCampaignLoading}
      />
    </Fragment>
  );

  function sendForApproval() {
    setLockCampaignLoading(true);
    axios({
      url: "/send/campaign/admin/approval",
      method: "POST",
      data: {
        campaign_id: formikProps.values.campaignID,
        brand_id: activeBrand.ID,
        user_id: userID,
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          message: response.data.approval_msg,
          adminApprovalStatus: response.data.approval_status,
        }));
        dispatch(
          alert({
            type: "success",
            message: response.data.approval_msg,
          })
        );
        setLockCampaignLoading(false);
        setDialog({ state: false });
      }
    });
  }

  function handleLockCampaign() {
    setLockCampaignLoading(true);
    axios({
      url: "/user/lockCampaign",
      method: "POST",
      disableRedirect: true,
      data: {
        campaign_id: formikProps.values.campaignID,
        sender_brandId: formikProps.values.brandID,
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          status: response?.data?.status,
          campaignStatus: response.data?.status,
        }));

        setLockCampaignLoading(false);

        dispatch(
          alert({
            type: "success",
            message: response.message.displayMessage,
          })
        );
      }
      setDialog({ state: false });
    });
  }

  function handleDownloadReport() {
    setLoading(true);
    let url = "/brand/campaign/report/" + formikProps.values?.campaignID;
    if (component === "request") {
      url = "/contributer/campaign/report/" + formikProps.values?.campaignID;
    }

    axios({
      url: url,
      disableRedirect: true,
    })
      .then((response) => {
        if (response.status) {
          window.location.href = response?.data?.reportUrl;
          dispatch(
            alert({
              type: "success",
              message: "Report was successfully downloaded.",
            })
          );
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }
}
